import {JobType} from '../../../../../api/types/aiReview.type';
import {AI_REVIEW_JOB_TYPE} from '../../constant/AiReviewConstants';
import {
  IssueCodeDefinition,
  JobDetailFormData,
  ProtocolFormData,
} from '../../../../../redux/slice/aiReviewSliceV2';

const hasText = (value?: string | null): boolean =>
  Boolean(value && value.trim().length > 0);

const isCompleteIssueCode = (code: IssueCodeDefinition): boolean =>
  hasText(code.code_id) &&
  hasText(code.code_name) &&
  hasText(code.category) &&
  hasText(code.priority) &&
  hasText(code.definition);

/**
 * Submit enablement for create-job (AVR-22264).
 * Draft only requires a valid job name; submit requires source + protocol fields.
 * Edit responses do not include a source document count, so edit validation
 * relies on the persisted source association instead.
 * Protocol tab edits live on the protocol slice — prefer those when present.
 */
export const canSubmitCreateJob = (
  formData: JobDetailFormData,
  jobType: JobType,
  protocol?: ProtocolFormData,
  isEditFlow = false
): boolean => {
  const jobName = formData.jobDetail?.jobName ?? '';
  if (!hasText(jobName)) {
    return false;
  }

  if (
    !formData.sourceSelection ||
    (!isEditFlow && Number(formData.totalDocs) <= 0)
  ) {
    return false;
  }

  const caseContext = protocol?.caseContext ?? formData.caseContext;
  if (!hasText(caseContext?.executive_summary)) {
    return false;
  }

  if (jobType === AI_REVIEW_JOB_TYPE.relevancy) {
    const relevance = protocol?.relevanceCriteria ?? formData.relevanceCriteria;
    return hasText(relevance?.master_relevance_standard);
  }

  if (jobType === AI_REVIEW_JOB_TYPE.issueCoding) {
    const issueCoding = protocol?.issueCoding ?? formData.issueCoding;
    return (issueCoding?.issue_codes ?? []).some(isCompleteIssueCode);
  }

  return false;
};
